var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgVisits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E8CF6E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.78 11.452h-6.577v-2.07a.478.478 0 0 0-.482-.481H15.28a.478.478 0 0 0-.482.482v2.069H8.22a.75.75 0 0 0-.737.737v14.939c0 .396.34.737.737.737h19.588a.75.75 0 0 0 .737-.737V12.189c-.028-.397-.34-.737-.765-.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EE",
    d: "M9.269 13.238h17.49v12.841H9.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84DBFF",
    d: "M15.874 9.865h4.28v.907h-4.28z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#324A5E",
    transform: "translate(10.843 4.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.372.014h3.543v5.528H5.372z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.991,
    cy: 13.054,
    r: 1.587
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.939 18.354v-1.7c0-.794-.624-1.418-1.418-1.418H1.46c-.794 0-1.417.624-1.417 1.418v1.7h5.896z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CED5E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.54 15.307h7.114v1.106H18.54zM18.539 17.83h7.115v1.105h-7.115zM18.539 20.353h7.115v1.105h-7.115z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EE",
    d: "M18.539 22.904h3.515v1.105h-3.515z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6.378,
    r: 1,
    fill: "#FFD05B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisits);
export default __webpack_public_path__ + "static/media/visits.3bc71ce01f8eff87b3660c1b38a7be43.svg";
export { ForwardRef as ReactComponent };